import { useState, useEffect } from "react";
import Modal from "../../../components/Modal/Modal";

const RenameVersionModal = ({ open, close, current, save }) => {
  const [name, setName] = useState(current);

  useEffect(() => {
    if (open) setName(current);
  }, [open, current]);

  return (
    <Modal open={open} close={close}>
      <h2>Sürüm Adını Değiştir</h2>
      <input
        className="modal-input"
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
      />
      <div className="modal-buttons">
        <button
          className="modal-add-button"
          onClick={() => {
            save(name);
            close();
          }}
        >
          Kaydet
        </button>
        <button className="modal-close-button" onClick={close}>
          İptal
        </button>
      </div>
    </Modal>
  );
};

export default RenameVersionModal;
